const SYMBOLS = {
  EUR: "€", USD: "$", CHF: "CHF ", CAD: "CA$", GBP: "£", SEK: "kr ", NOK: "kr ",
  DKK: "kr ", ISK: "kr ", BRL: "R$", ARS: "AR$", CLP: "CH$", COP: "COL$", PEN: "S/ ",
  JPY: "¥", AUD: "A$", NZD: "NZ$", CNY: "CN¥", SGD: "S$",
  KRW: "₩", TWD: "NT$", INR: "₹", THB: "฿", MYR: "RM ", IDR: "Rp ", PHP: "₱", VND: "₫",
  AED: "AED ", SAR: "SAR ", QAR: "QAR ", KWD: "KWD ", BHD: "BHD ", OMR: "OMR ",
  BGN: "BGN ", CZK: "Kč ", HUF: "Ft ", PLN: "zł ", RON: "lei ",
  RSD: "дин ", UAH: "₴", BAM: "KM ", ALL: "L ", MKD: "ден ", MDL: "L ",
};

// Approx. static reference rates (units of currency per 1 EUR), Aug 2026 — fallback only,
// used until live rates load from GET /api/fx-rates (see hooks/useFxRates.js).
const FALLBACK_UNITS_PER_EUR = {
  EUR: 1, USD: 1.1662, CHF: 0.9361, CAD: 1.6163, GBP: 0.855, SEK: 11.0668, NOK: 10.892,
  DKK: 7.4753, ISK: 143.2, BRL: 6.0153, ARS: 1687.4424, CLP: 1066.5249,
  COP: 3652.7346, PEN: 3.88, JPY: 180.0, AUD: 1.77, NZD: 1.98, CNY: 8.35, SGD: 1.52,
  KRW: 1520.0, TWD: 34.5, INR: 96.0, THB: 37.5, MYR: 4.85, IDR: 17600.0, PHP: 63.0, VND: 27500.0,
  AED: 4.28, SAR: 4.37, QAR: 4.24, KWD: 0.358, BHD: 0.438, OMR: 0.449,
  BGN: 1.9558, CZK: 24.5, HUF: 400.0, PLN: 4.28, RON: 5.08,
  // Not covered by the live ECB-based FX feed — static fallback only.
  RSD: 117.2, UAH: 46.5, BAM: 1.9558, ALL: 99.5, MKD: 61.5, MDL: 19.8,
};

let liveUnitsPerEUR = null;
let liveRateDate = null;

export function setLiveFxRates(rates, rateDate) {
  const map = { EUR: 1 };
  rates.forEach((r) => { map[r.currency] = r.units_per_eur; });
  liveUnitsPerEUR = map;
  liveRateDate = rateDate;
}

export function getFxRateDate() {
  return liveRateDate;
}

export function toEUR(value, currency) {
  const table = liveUnitsPerEUR || FALLBACK_UNITS_PER_EUR;
  const rate = table[currency] ?? FALLBACK_UNITS_PER_EUR[currency] ?? 1;
  return value / rate;
}

export function formatEUR(value) {
  return formatMoney(Math.round(value * 100) / 100, "EUR");
}

// US-located banks (retail or private banking) display fees natively in USD.
// Every other country keeps converting to EUR for cross-currency comparison.
export function isUSBank(bank) {
  return bank?.country === "United States";
}

// The currency fee amounts for this bank should be shown in (the "primary" display currency).
export function primaryCurrency(bank) {
  return isUSBank(bank) ? (bank?.currency || "USD") : "EUR";
}

// Primary fee display: native USD for US banks, EUR-converted for everyone else.
export function formatPrimaryFee(value, bank) {
  return isUSBank(bank) ? formatMoney(value, bank.currency || "USD") : formatEUR(toEUR(value, bank.currency));
}

export function formatMoney(value, currency) {
  const symbol = SYMBOLS[currency] || `${currency} `;
  const num = Number(value);
  const formatted = num % 1 === 0 ? num.toLocaleString() : num.toFixed(2);
  return value === 0 ? "Free" : `${symbol}${formatted}`;
}

export function formatPct(value) {
  return value === 0 ? "0%" : `${value}%`;
}

export function formatDate(isoDate) {
  if (!isoDate) return "—";
  const d = new Date(`${isoDate}T00:00:00Z`);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
}
